function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M96.918 86.903l-.055-.042.054.052s-42.602 4.15-67.124-19.2C1.275 40.55 7.198 9.345 8.376 5.64c0 0 .062-.167.076-.185 3.59-1.487 34.113-9.873 63.604 16.221 25.365 22.426 24.862 65.227 24.862 65.227z",
  fill: "#235544"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M31.9 24.758c-2.552.698-6.566 3.148-4.246 8.357 1.838 4.128 8.912 11.9 16.673 17.728 3.41 2.561 6.199 2.458 8.597 1.033",
  stroke: "#fff",
  strokeWidth: 3.057
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M32.583 24.354c-.47.128-1.668.72-2.186.972",
  stroke: "#1FA956",
  strokeWidth: 6.115,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M52.925 51.877c1.053.91 2.835 3.181 2.967 4.993.213 2.943-3.092 6.442.045 10.412 2.476 3.135 8.093 2.254 8.617-3.584",
  stroke: "#1FA956",
  strokeWidth: 3.057
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M52.924 51.876c-2.398 1.425-5.187 1.528-8.597-1.033a82.513 82.513 0 01-7.823-6.713",
  stroke: "#1FA956",
  strokeWidth: 5.35
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M39.093 20.485c1.835-1.909 5.905-4.261 9.37.267 2.746 3.589 6.189 13.518 7.596 23.121.618 4.22-.806 6.62-3.204 8.045",
  stroke: "#fff",
  strokeWidth: 3.057
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M52.813 51.943c2.398-1.425 3.822-3.825 3.204-8.044-.501-3.42-1.26-6.88-2.154-10.08",
  stroke: "#1FA956",
  strokeWidth: 5.35
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M38.255 20.983c.337-.35 1.43-1.12 1.9-1.455",
  stroke: "#1FA956",
  strokeWidth: 6.115,
  strokeLinecap: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 65.891,
  cy: 57.683,
  r: 5.862,
  transform: "rotate(-30.714 65.891 57.683)",
  fill: "#fff",
  stroke: "#1FA956",
  strokeWidth: 3.057
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 65.892,
  cy: 57.683,
  r: 3.168,
  transform: "rotate(-30.714 65.892 57.683)",
  fill: "#1FA956"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 84.254,
  y: 41.108,
  width: 7.391,
  height: 21.352,
  rx: 3.696,
  transform: "rotate(115.911 84.254 41.108)",
  fill: "#fff"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M75.76 36.981l-3.23 6.648-1.477-.717 3.23-6.648z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M34.75 67.28a5.543 5.543 0 119.53-5.662 5.543 5.543 0 01-9.53 5.663z",
  fill: "#F5BED7"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 35.305,
  y: 65.711,
  width: 8.528,
  height: 1.706,
  rx: 0.853,
  transform: "rotate(-30.714 35.305 65.71)",
  fill: "#333"
});

function SvgImgPrescription1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
}

export default "data:image/svg+xml;base64,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";
export { SvgImgPrescription1 as ReactComponent };